import { render } from "./Home.vue?vue&type=template&id=3bb6cddd"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script